import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { FileText, TrendingUp, DollarSign, PieChart } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const AccountsReports = () => {
  const navigate = useNavigate();

  const reports = [
    { title: 'Income Report', description: 'View all income transactions and summary', icon: DollarSign, path: '/accounts/income-report', color: 'green' },
    { title: 'Suppliers Report', description: 'View all suppliers and outstanding balances', icon: FileText, path: '/accounts/suppliers-report', color: 'blue' },
    { title: 'Suppliers Ledger', description: 'View detailed supplier transactions', icon: FileText, path: '/accounts/suppliers-ledger', color: 'purple' },
    { title: 'Assets Report', description: 'View all assets and depreciation', icon: PieChart, path: '/accounts/assets-report', color: 'orange' },
    { title: 'Income & Expenses Report', description: 'Compare income vs expenses', icon: TrendingUp, path: '/accounts/income-expenses-report', color: 'indigo' },
    { title: 'Profit & Loss Statement', description: 'View profit/loss for selected period', icon: TrendingUp, path: '/accounts/profit-loss', color: 'cyan' },
    { title: 'Balance Sheet', description: 'View complete balance sheet', icon: PieChart, path: '/accounts/balance-sheet', color: 'pink' },
  ];

  const getColorClasses = (color) => {
    const colors = {
      green: 'bg-green-50 hover:bg-green-100 border-green-200',
      blue: 'bg-blue-50 hover:bg-blue-100 border-blue-200',
      purple: 'bg-purple-50 hover:bg-purple-100 border-purple-200',
      orange: 'bg-orange-50 hover:bg-orange-100 border-orange-200',
      indigo: 'bg-indigo-50 hover:bg-indigo-100 border-indigo-200',
      cyan: 'bg-cyan-50 hover:bg-cyan-100 border-cyan-200',
      pink: 'bg-pink-50 hover:bg-pink-100 border-pink-200',
    };
    return colors[color] || colors.blue;
  };

  const getIconColorClass = (color) => {
    const colors = {
      green: 'text-green-600',
      blue: 'text-blue-600',
      purple: 'text-purple-600',
      orange: 'text-orange-600',
      indigo: 'text-indigo-600',
      cyan: 'text-cyan-600',
      pink: 'text-pink-600',
    };
    return colors[color] || colors.blue;
  };

  return (
    <div className="p-6">
      <Card>
        <CardHeader>
          <CardTitle>Accounts Reports</CardTitle>
          <p className="text-sm text-gray-500">Access all accounting reports and statements</p>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {reports.map((report) => {
              const Icon = report.icon;
              return (
                <button
                  key={report.path}
                  onClick={() => navigate(report.path)}
                  className={`p-6 border-2 rounded-lg text-left transition-all ${getColorClasses(report.color)}`}
                >
                  <div className="flex items-start gap-4">
                    <div className={`p-3 rounded-lg bg-white`}>
                      <Icon className={`w-6 h-6 ${getIconColorClass(report.color)}`} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-semibold text-lg mb-1">{report.title}</h3>
                      <p className="text-sm text-gray-600">{report.description}</p>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccountsReports;